$(function() {

    //Slider init default
    $('.slider-init').slick();



    //Slider init with thumbnails
    $('.slider-init-thumbnails').slick({
        asNavFor: '.slider-init-thumbnails-nav-1',
        arrows: false,
    });

    $('.slider-init-thumbnails-nav-1').slick({
        slidesToShow: 1.7,
        slidesToScroll: 1,
        infinite: false,
        // asNavFor: '.slider-init-thumbnails',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: false,
                }
            },
            {
                breakpoint: 928,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: false,
                    infinite: false,

                }
            },
        ]
    });

    $('.slider-init-thumbnails-nav').slick({
        slidesToShow: 1.7,
        slidesToScroll: 1,
        infinite: false,
        // asNavFor: '.slider-init-thumbnails',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: false,
                }
            },
            {
                breakpoint: 928,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: false,
                    infinite: false,

                }
            },
        ]
    });

    if($('.slider-init-custom[data-slide="product-slider"]')[0]){

        $('.slider-init-custom[data-slide="product-slider"]').slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            rows: 0,
            prevArrow: $(".arrow-prev"),
            nextArrow: $(".arrow-next"),
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4
                    }
                },
            ]
        });
    }

    if($('.slider-init-custom[data-slide="single"]')[0]){

        $('.slider-init-custom[data-slide="single"]').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
        })

        $('.slider-thumbnail').on('click', function(){
            var slideNumber = $(this).data('number');
            $('.slider-init-custom[data-slide="single"]').slick('slickGoTo', slideNumber);
        })

    }

    if($('.slider-init-custom[data-slide="project"]')[0]){
        $('.slider-init-custom[data-slide="project"]').slick({
            slidesToShow: 1.5,
            slidesToScroll: 1,
            arrows: false,
            mobileFirst: true,
            centerMode: false,
            infinite: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
            ]
        })
    }

});